import CryptoJS from "crypto-js";
import { CommonConstant } from "@/const/common.constant.js";

const encypt = password => {
  // eslint-disable-next-line
  const shaObj = new jsSHA("SHA-512", "TEXT");
  shaObj.update(password);
  return shaObj.getHash("HEX");
};
const aesEncrypt = (value, key) => {
  const cipher = CryptoJS.AES.encrypt(value, key);
  return cipher.toString();
};
const aesDecrypt = (value, key) => {
  const decipher = CryptoJS.AES.decrypt(value, key);
  return decipher.toString(CryptoJS.enc.Utf8);
};

const getCookieValue = key => {
  const reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
  const cookieArr = document.cookie.match(reg);
  return cookieArr ? cookieArr[2] : "";
};
const setCookie = (key, value, expireDay) => {
  const expireDate = new Date();
  expireDay = expireDay || 7;
  expireDate.setDate(expireDate.getDate() + expireDay);
  let cookieValue = getCookieValue(CommonConstant.COOKIE_NAME);
  if (cookieValue) {
    const decrypt = JSON.parse(aesDecrypt(cookieValue, CommonConstant.AESKey));
    decrypt[key] = value;
    cookieValue = aesEncrypt(JSON.stringify(decrypt), CommonConstant.AESKey);
  } else {
    cookieValue = aesEncrypt(
      JSON.stringify({ [key]: value }),
      CommonConstant.AESKey
    );
  }
  document.cookie = `${CommonConstant.COOKIE_NAME
    }=${cookieValue};expires=${expireDate.toUTCString()};domain=${CommonConstant.COOKIE_DOMAIN
    };path=/`;
};

const getCookie = key => {
  const cookieValue = getCookieValue(CommonConstant.COOKIE_NAME);
  let value;
  if (cookieValue) {
    const decrypt = JSON.parse(aesDecrypt(cookieValue, CommonConstant.AESKey));
    value = decrypt[key];
  }
  return value;
};

const getUUID = () => {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}

export const CommonHelper = {
  encypt,
  aesEncrypt,
  aesDecrypt,
  getCookieValue,
  setCookie,
  getCookie,
  getUUID,
};
